import { useLocation } from "react-router";
import bhumeet from "../../assets/bhumeet.svg";
import { useEffect, useState } from "react";
import Loading from "../../ReusableFunctions/Loader";
import Popup from "../../ReusableFunctions/Popup";
import dateFormat from "dateformat";
import {
  getDebitNoteInvoiceDetails,
  getSettlementInvoiceDetails,
} from "../../apis/settlements";
import {
  formatAmountWithSymbol,
  formatToIndianRupees,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dashLine from "../../assets/dashLine.svg";
import { DSP_INVOICES_TYPES } from "../../appConstants";
import { useSelector } from "react-redux";

const DspInvoiceDetails = () => {
  const user = useSelector((state) => state.user?.user);
  const { dsp, invoice } = useLocation().state;
  // Debit notes belong to a settlement invoice and have no request_id.
  const isDebitNote = Boolean(invoice?.dn_number);
  console.log("DSP OBJECT:", dsp);
  console.log("invoiceDATA ", invoice);
  const [settInvoice, setSettInvoice] = useState({});
  const [isDownload, setIsDownload] = useState(false);
  const [serviceInvoices, setServiceInvoices] = useState([]);

  const splitArrayIntoChunks = (array, chunkSize) => {
    let result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };
  const getSettelementInvoiceDetailsFunc = async () => {
    try {
      Loading.set(true);
      const settleInvoice = isDebitNote
        ? await getDebitNoteInvoiceDetails(invoice?.id)
        : await getSettlementInvoiceDetails(invoice?.request_id);
      const invoiceDate =
        settleInvoice?.created_at || settleInvoice?.generated_time;
      const array = settleInvoice?.serviceInvoices;
      setServiceInvoices(array);
      const splitInvolices = splitArrayIntoChunks(array || [], 16);

      setSettInvoice({
        ...settleInvoice,
        time: new Date(settleInvoice?.time),
        invoice_id: invoice?.id,
        // generated_time: new Date(settleInvoice?.generated_time),
        generated_time: invoiceDate ? new Date(invoiceDate) : null,
        to_bank_account_name: settleInvoice?.dsp_bank_account?.bank_name,
        to_bank_account_ifsc: settleInvoice?.dsp_bank_account?.ifsc_code,
        to_bank_account_number: settleInvoice?.dsp_bank_account?.account_no,
        to_bank_account_holder_name:
          settleInvoice?.dsp_bank_account?.account_holder_name,
        serviceInvoices: splitInvolices,
      });

      Loading.set(false);
    } catch (error) {
      Loading.set(false);
      Popup.alert("Error", error, "ERROR");
    }
  };

  const wait = async () => {
    return new Promise((resolve) => {
      setTimeout(resolve, 0);
    });
  };

  const getTotalServiceAmount = () => {
    let dspSettlementInvoices = settInvoice.dspSettlementInvoices.map(
      (inv) => ({ ...inv, service_amount: Number(inv.service_amount) }),
    );
    return dspSettlementInvoices?.reduce(
      (total, invoice) => total + invoice.service_amount,
      0,
    );
  };

  const downloadPDF = async () => {
    setIsDownload(true);
    Loading.set(true);

    if (serviceInvoices) {
      const splitArray1 = splitArrayIntoChunks(serviceInvoices, 18);
      setSettInvoice((prev) => ({ ...prev, serviceInvoices: splitArray1 }));
    }

    await wait();

    const imgWidth = 210;
    const pageHeight = 297;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const addElementToPdf = async (element, isFirstPage, scale = 1.2) => {
      if (!element) return;

      const canvas = await html2canvas(element, {
        scale: scale,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        imageTimeout: 15000,
        allowTaint: false,
      });

      if (!canvas || canvas.width === 0 || canvas.height === 0) return;

      const imgData = canvas.toDataURL("image/jpeg", 0.8);
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (!imgHeight || isNaN(imgHeight)) return;

      let heightLeft = imgHeight;
      let position = 0;

      if (!isFirstPage) pdf.addPage();

      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      pdf.setFontSize(10);
      pdf.text(`Page ${pdf.getNumberOfPages()}`, 105, 293, { align: "center" });
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        pdf.setFontSize(10);
        pdf.text(`Page ${pdf.getNumberOfPages()}`, 105, 293, {
          align: "center",
        });
        heightLeft -= pageHeight;
      }
    };

    const invoiceSection = document.getElementById("invoice-main-section");
    const debitSection = document.getElementById("debit-note-section");

    if (invoiceSection && debitSection) {
      await addElementToPdf(invoiceSection, true, 2);
      await addElementToPdf(debitSection, false, 2);
    } else {
      const fullDiv = document.querySelector(".myDiv");
      await addElementToPdf(fullDiv, true, 1.2);
    }

    pdf.save("invoice.pdf");

    if (serviceInvoices) {
      const splitArray2 = splitArrayIntoChunks(serviceInvoices, 16);
      setSettInvoice((prev) => ({ ...prev, serviceInvoices: splitArray2 }));
    }

    setIsDownload(false);
    Loading.set(false);
  };
  useEffect(() => {
    getSettelementInvoiceDetailsFunc();
  }, []);
  console.log("settInvoiceDataaaaa", settInvoice);
  const DebitNotesDetailsContainer = ({ DebitNote }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem",
          // marginTop: isDownload ? "610px" : "",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            fontSize: "14px",
            marginTop: "10px",
          }}
        >
          <span style={{ fontSize: "18px", fontWeight: 700 }}> Debit Note</span>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid rgba(215, 218, 224, 0.6)",
              padding: "10px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.8rem",
                maxWidth: "60%",
              }}
            >
              <div style={{ marginTop: "8px" }}>
                <p style={{ margin: "0", fontWeight: 500 }}>From</p>
                <p
                  style={{ margin: "0", fontWeight: "bold", color: "#1E1E1E" }}
                >
                  {DebitNote?.from?.name}
                </p>
                <p style={{ margin: "0" }}>{DebitNote?.from?.address}</p>
                {DebitNote?.from?.gstin && (
                  <p style={{ margin: "0" }}>{DebitNote?.from?.gstin}</p>
                )}
              </div>
              <div style={{ marginBottom: "5px" }}>
                <p style={{ margin: "0", fontWeight: 500 }}>To</p>
                <p
                  style={{ margin: "0", fontWeight: "bold", color: "#1E1E1E" }}
                >
                  {DebitNote?.to?.name || "-"}
                </p>
                <p style={{ margin: "0" }}>
                  {settInvoice?.from?.address ||
                    `${dsp?.city || ""}, ${dsp?.state || ""}, ${dsp?.country || ""}` ||
                    ""}
                </p>
                {dsp?.country === "Morocco" && (
                  <p style={{ margin: "0" }}>VAT:{dsp?.gstin || "-"}</p>
                )}
                {/* <p style={{ margin: "0" }}>{DebitNote?.to?.address || "-"}</p> */}
                {DebitNote?.to?.mobileNumber && (
                  <p style={{ margin: "0" }}>{DebitNote?.to?.mobileNumber}</p>
                )}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  gap: "2px",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: "13px",
                    marginTop: "2px",
                  }}
                >
                  Date -
                </p>
                <p>{dateFormat(settInvoice?.generated_time, "dd mmm yyyy")}</p>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "2px",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: "13px",
                    marginTop: "2px",
                  }}
                >
                  D.N.NO.-
                </p>
                <p>{DebitNote?.dn_number}</p>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "2px",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: "13px",
                    marginTop: "2px",
                  }}
                >
                  Invoice NO. -
                </p>
                <p>{DebitNote.against_invoice_number} </p>
              </div>
            </div>
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: 700,
              padding: "10px 0px 40px 0px  ",
            }}
          >
            <p>
              This is debit note made against invoice No.
              {DebitNote.against_invoice_number}
            </p>
          </div>
        </div>
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              fontSize: "15px",
              display: "flex",
              justifyContent: "space-between",
              fontWeight: 700,
              borderTop: "1px solid rgba(215, 218, 224, 0.6) ",
              borderBottom: "1px solid rgba(215, 218, 224, 0.6)",
              padding: "10px 0px ",
            }}
          >
            <p>Description</p>
            <p>Amount</p>
          </div>
          <div
            style={{
              padding: "15px 0px ",
              display: "flex",
              flexDirection: "column",
              fontSize: "14px",
              gap: "10px",
            }}
          >
            {DebitNote.notes.length > 0 &&
              DebitNote.notes.map((n) => {
                return (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{n?.note}</p>
                    <p style={{ fontWeight: 700 }}>
                      {formatAmountWithSymbol(n?.amount, user?.country_code)}
                    </p>
                  </div>
                );
              })}
          </div>
          <div style={{ borderTop: "1px solid rgba(215, 218, 224, 0.6)" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
                gap: "2rem",
                fontWeight: 700,
              }}
            >
              <p>Total</p>
              <p>
                {formatAmountWithSymbol(
                  DebitNote?.amount ??
                    DebitNote?.notes?.reduce(
                      (total, n) => total + Number(n?.amount || 0),
                      0,
                    ),
                  user?.country_code,
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        overflow: "auto",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      {isDownload ? (
        <div
          style={{
            position: "relative",
            top: "10px",
            right: "-240px",
            fontSize: "14px",
          }}
        >
          Downloading...
        </div>
      ) : (
        <a
          onClick={downloadPDF}
          style={{
            position: "relative",
            top: "10px",
            right: "-240px",
            textDecoration: "underline",
            color: "#007BFF",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Download Invoice
        </a>
      )}

      <div className="myDiv" style={{ width: "620px" }}>
        <div id="invoice-main-section">
          <div
            style={{
              position: "absolute",
              left: "49.5%",
              transform: "translateX(-50%)",
              marginTop: "20px",
            }}
          >
            <p
              style={{
                margin: "0",
                fontSize: "16px",
                fontWeight: 700,
                color: "#1A1C21",
              }}
            >
              Tax Invoice
            </p>
          </div>
          <div
            style={{
              width: "620px",
              border: isDownload
                ? "none"
                : "1px solid rgba(215, 218, 224, 0.4)",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              color: "#3B3B3B",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  margin: "0px 30px",
                  padding: "20px 0px",
                  borderBottom: "1px solid rgba(215, 218, 224, 0.3)",
                  position: "relative",
                  marginTop: "50px",
                }}
              >
                <div>
                  <img src={bhumeet} alt="bhumeet" width={"120px"} />
                </div>

                <div style={{ textAlign: "right" }}>
                  <p style={{ margin: "0", fontSize: "13px" }}>
                    <span style={{ fontWeight: 600, color: "#1A1C21" }}>
                      Invoice No.
                    </span>{" "}
                    - {settInvoice?.invoice_number || "-"}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px" }}>
                    <span style={{ fontWeight: 600, color: "#1A1C21" }}>
                      Invoice Date -{" "}
                    </span>
                    <span style={{ color: "#5E6470" }}>
                      {dateFormat(settInvoice?.generated_time, "dd mmm yyyy")}
                    </span>
                  </p>
                  {settInvoice?.request?.req_number && (
                    <p style={{ margin: "0", fontSize: "13px" }}>
                      <span style={{ fontWeight: 600 }}>Request No.</span>
                      <span style={{ color: "#5E6470" }}>
                        -{settInvoice?.request?.req_number}
                      </span>
                    </p>
                  )}
                  {settInvoice?.invoice_currency && (
                    <p style={{ margin: "0", fontSize: "13px" }}>
                      <span style={{ fontWeight: 600, color: "#1A1C21" }}>
                        Transaction Currency -{" "}
                      </span>
                      <span style={{ color: "#5E6470" }}>
                        {settInvoice?.invoice_currency}
                      </span>
                    </p>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "#727272",
                  padding: "20px 30px",
                }}
              >
                <div>
                  <div style={{ marginBottom: "20px" }}>
                    <p style={{ margin: "0", fontWeight: 500 }}>To</p>
                    <p
                      style={{
                        margin: "0",
                        fontWeight: "bold",
                        color: "#1E1E1E",
                      }}
                    >
                      {settInvoice?.to?.name}
                    </p>
                    <p
                      style={{
                        margin: "0",
                        maxWidth: "300px",
                        wordBreak: "break-word",
                        lineHeight: "1.5",
                      }}
                    >
                      {settInvoice?.to?.address}
                      <br />
                      {settInvoice?.location_name
                        ? `${settInvoice?.location_name}`
                        : ""}
                    </p>
                    {settInvoice?.to?.gstin && (
                      <p style={{ margin: "0" }}>{settInvoice?.to?.gstin}</p>
                    )}
                  </div>
                  <div>
                    <div>
                      <p style={{ margin: "0", fontWeight: 500 }}>From</p>
                      <p
                        style={{
                          margin: "0",
                          fontWeight: "bold",
                          color: "#1E1E1E",
                        }}
                      >
                        {settInvoice?.from?.name || "-"}
                      </p>
                      <p
                        style={{
                          margin: "0",
                          maxWidth: "300px",
                          wordBreak: "break-word",
                          lineHeight: "1.5",
                        }}
                      >
                        {settInvoice?.from?.address ||
                          `${dsp?.city || ""}, ${dsp?.state || ""}, ${dsp?.country || ""}` ||
                          ""}
                      </p>
                      {/* {settInvoice?.dsp_gstin && (
                        <p style={{ margin: "0" }}>
                          Tax ID: {settInvoice?.dsp_gstin}
                        </p>
                      )} */}
                      {settInvoice?.dsp_gstin && (
                        <p>Tax ID: {settInvoice?.dsp_gstin}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* SERVICE DETAILS SECTION */}
              <div
                style={{
                  backgroundColor: "#D9D9D9",
                  padding: "10px 25px",
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 700,
                  color: "#1E1E1E",
                  height: "50px",
                  alignItems: "center",
                  fontSize: "18px",
                }}
              >
                <span>Service Details</span>
              </div>

              <div
                style={{
                  padding: "10px 30px 20px",
                  borderBottom: "1px solid rgba(215,218,224,0.6)",
                }}
              >
                {settInvoice?.request?.crop_name && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: 500,
                      marginBottom: "8px",
                    }}
                  >
                    <span>Crop</span>
                    <span>{settInvoice?.request?.crop_name}</span>
                  </div>
                )}
                {settInvoice?.request?.pesticides && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: 500,
                      marginBottom: "8px",
                    }}
                  >
                    <span>Agrochemical</span>
                    <span style={{ maxWidth: "60%", textAlign: "right" }}>
                      {settInvoice?.request?.pesticides}
                    </span>
                  </div>
                )}
                {settInvoice?.request?.service_completed_area && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: 500,
                      marginBottom: "8px",
                    }}
                  >
                    <span>Area</span>
                    <span>
                      {settInvoice?.request?.price_by === "acre"
                        ? squareKilometersToAcres(
                            settInvoice?.request?.service_completed_area,
                          )
                        : Number(
                            settInvoice?.request?.service_completed_area,
                          )}{" "}
                      {settInvoice?.request?.price_by === "tank"
                        ?"Tanks":dsp?.settings?.units}
                    </span>
                  </div>
                )}
              </div>
              <div
                style={{
                  backgroundColor: "#D9D9D9",
                  padding: "10px 25px",
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 700,
                  color: "#1E1E1E",
                  height: "50px",
                  alignItems: "center",
                  fontSize: "18px",
                }}
              >
                <span>Payment Summary</span>
                <span>Rates</span>
              </div>

              <div style={{ padding: "10px 30px 10px" }}>
                {/* {settInvoice?.service_amount > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Service Charges</span>
                      <span>
                        {formatAmountWithSymbol(
                          settInvoice?.service_amount || 0,
                          user?.country_code,
                          user?.dsp?.invoice_currency,
                        )}
                      </span>
                    </div>
                    {settInvoice?.descriptions?.service_amount && (
                      <div style={{ fontSize: "12px", color: "#848484" }}>
                        ({settInvoice?.descriptions?.service_amount})
                      </div>
                    )}
                  </div>
                )} */}
                {settInvoice?.service_amount > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Service Charges</span>
                      <span>
                        {formatAmountWithSymbol(
                          settInvoice?.service_amount || 0,
                          user?.country_code,
                          settInvoice?.invoice_currency ||
                            user?.dsp?.invoice_currency,
                        )}
                      </span>
                    </div>

                    {/* Dynamic area x rate */}
                    {settInvoice?.request &&
                      (() => {
                        const req = settInvoice?.request;
                        const field_area =
                          req?.price_by === "acre"
                            ? squareKilometersToAcres(
                                req?.service_completed_area || req?.field_area,
                              )
                            : req?.service_completed_area || req?.field_area;
                        const per_acre_charge =
                          Number(settInvoice?.service_amount) /
                          Number(field_area);
                        return (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#848484",
                              marginTop: "3px",
                            }}
                          >
                            ({Number(field_area).toFixed(2)}{" "}
                            {/* {req?.price_by === "acre" ? "Acres" : "Tanks"}  */}
                            {
                            req?.price_by === "tank"?"Tank":dsp?.settings?.units||"Acre"
                            }
                            X{" "}
                            {formatAmountWithSymbol(
                              per_acre_charge,
                              user?.country_code,
                              settInvoice?.invoice_currency ||
                                user?.dsp?.invoice_currency,
                            )}{" "}
                            per { req?.price_by === "tank"?"Tank":dsp?.settings?.units||"Acre"})
                          </div>
                        );
                      })()}
                    {settInvoice?.descriptions?.service_amount && (
                      <div style={{ fontSize: "12px", color: "#848484" }}>
                        ({settInvoice?.descriptions?.service_amount})
                      </div>
                    )}
                  </div>
                )}
                {Number(settInvoice?.pesticides_subsidy) > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Subsidy</span>
                      <span style={{ color: "red" }}>
                        -{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.pesticides_subsidy || 0,
                          user?.country_code,
                          settInvoice?.invoice_currency ||
                            user?.dsp?.invoice_currency,
                        )}
                      </span>
                    </div>
                  </div>
                )}
                {Number(settInvoice?.total_discounted_amount_via_dsp) > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Discount</span>
                      <span style={{ color: "red" }}>
                        -{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.total_discounted_amount_via_dsp || 0,
                          user?.country_code,
                          settInvoice?.invoice_currency ||
                            user?.dsp?.invoice_currency,
                        )}
                      </span>
                    </div>
                  </div>
                )}
                {!settInvoice?.bhumeet_coupons_amount <= 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>BhuMeet Coupon Redeemed</span>
                      <span style={{}}>
                        +{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.bhumeet_coupons_amount || 0,
                          user?.country_code,
                        )}
                      </span>
                    </div>
                    {/* {settInvoice?.descriptions?.bhumeet_coupons_amount &&
                                    <div style={{ fontSize: '12px', color: "#848484" }}>({settInvoice?.descriptions?.bhumeet_coupons_amount})</div>
                                } */}
                  </div>
                )}
                {!settInvoice?.incentive_from_bhumeet_amount <= 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Incentive Offer</span>
                      <span style={{}}>
                        {settInvoice.service_amount > 0 ? "+" : ""}{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.incentive_from_bhumeet_amount || 0,
                          user?.country_code,
                        )}
                      </span>
                    </div>
                    {settInvoice?.descriptions
                      ?.incentive_from_bhumeet_amount && (
                      <div style={{ fontSize: "12px", color: "#848484" }}>
                        (
                        {
                          settInvoice?.descriptions
                            ?.incentive_from_bhumeet_amount
                        }
                        )
                      </div>
                    )}
                  </div>
                )}
                {/* <img src={dashLine} alt="dashLine" style={{ maxWidth: "103%" }} /> */}
                {settInvoice.invoice_type ===
                  DSP_INVOICES_TYPES.DEBIT_FOR_DSP &&
                  Number(settInvoice.service_amount) ===
                    Number(settInvoice?.total_dsp_amount) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                        fontWeight: 500,
                      }}
                    >
                      <span>Subtotal</span>
                      <span>
                        {formatAmountWithSymbol(
                          settInvoice?.total_dsp_amount || 0,
                          user?.country_code,
                        )}
                      </span>
                    </div>
                  )}
                {/* <div style={{ marginTop: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: 500,
                  }}
                >
                  <span>
                    Platform Fees
                    {settInvoice?.descriptions?.platform_fees_amount && (
                      <span
                        style={{
                          padding: "2px 5px",
                          borderRadius: "3px",
                          fontSize: "12px",
                          color: "#848484",
                        }}
                      >
                        ({settInvoice?.descriptions?.platform_fees_amount})
                      </span>
                    )}
                  </span>
                  <span style={{}}>
                    -{" "}
                    {formatAmountWithSymbol(
                      settInvoice?.platform_fees_amount || 0,
                      user?.country_code,
                    )}
                  </span>
                </div>
              </div> */}
                {Number(settInvoice?.tds_charges) <= 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>
                        TDS{" "}
                        {settInvoice.invoice_type ===
                        DSP_INVOICES_TYPES.INCENTIVE_TO_DSP
                          ? "94R"
                          : "94C"}
                        {settInvoice?.descriptions?.tds_charges && (
                          <span
                            style={{
                              padding: "2px 5px",
                              borderRadius: "3px",
                              fontSize: "12px",
                              color: "#848484",
                            }}
                          >
                            ({settInvoice?.descriptions?.tds_charges})
                          </span>
                        )}
                      </span>
                      <span style={{}}>
                        -{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.tds_charges,
                          user?.country_code,
                        )}
                      </span>
                    </div>
                  </div>
                )}
                {Number(settInvoice?.applied_tax_amount) > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 500,
                      }}
                    >
                      <span>Tax ({settInvoice?.tax}%)</span>
                      <span>
                        +{" "}
                        {formatAmountWithSymbol(
                          settInvoice?.applied_tax_amount || 0,
                          user?.country_code,
                          settInvoice?.invoice_currency,
                        )}
                      </span>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: "10px",
                    marginTop: "10px",
                    marginBottom: "30px",
                    fontWeight: "bold",
                    borderTop: "1px solid rgba(215, 218, 224, 0.6)",
                    borderBottom: "1px solid rgba(215, 218, 224, 0.6)",
                    paddingBottom: "10px",
                    fontSize: "18px",
                    marginBottom:
                      isDownload &&
                      settInvoice.invoice_type ===
                        DSP_INVOICES_TYPES.DEBIT_FOR_BHUMEET
                        ? "50px"
                        : isDownload &&
                            settInvoice.invoice_type ===
                              DSP_INVOICES_TYPES.DEBIT_FOR_DSP
                          ? "120px"
                          : "",
                  }}
                >
                  <span>Total Amount</span>
                  <span>
                    {/* {formatAmountWithSymbol(
                      settInvoice?.total_dsp_amount_to_be_paid || 0,
                      user?.country_code,
                      user?.dsp?.invoice_currency,
                    )} */}
                    {formatAmountWithSymbol(
                      settInvoice?.total_amount || 0,
                      user?.country_code,
                      // user?.dsp?.invoice_currency,
                      settInvoice?.invoice_currency,
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            {settInvoice.invoice_type ===
            DSP_INVOICES_TYPES.INCENTIVE_TO_DSP ? (
              <>
                <div
                  style={{
                    width: "620px",
                    // marginTop: isDownload ? "200px" : "40px",
                    marginTop: "40px",
                    border: "1px solid rgba(215, 218, 224, 0.4)",
                    borderRadius: "5px",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                    color: "#3B3B3B",
                    backgroundColor: "#fff",
                  }}
                >
                  <div
                    className={`reusable-table-containar scroll-container`}
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <table className={`reusable-table-view`}>
                        <thead style={{ width: "100%" }}>
                          <tr
                            className="reusable-table-view-header-row"
                            style={{
                              height: isDownload ? "30px" : "45px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <th
                              style={{
                                textAlign: "center",
                                width: "20%",
                                display: "inline-block",
                                fontSize: isDownload ? "11px" : "12px",
                              }}
                            >
                              Invoice No.
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                width: "40%",
                                display: "inline-block",
                                fontSize: isDownload ? "11px" : "12px",
                              }}
                            >
                              Date
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                width: "20%",
                                display: "inline-block",
                                fontSize: isDownload ? "11px" : "12px",
                              }}
                            >
                              Charges
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {settInvoice?.dspSettlementInvoices?.map(
                            (sI, index) => {
                              return (
                                <>
                                  <tr
                                    key={index}
                                    className="reusable-table-view-data-row"
                                    style={{
                                      height: isDownload ? "30px" : "45px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                    align="center"
                                  >
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%",
                                        border: "none",
                                        width: "20%",
                                      }}
                                    >
                                      {sI?.invoice_number}
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%",
                                        border: "none",
                                        width: "40%",
                                      }}
                                    >
                                      {dateFormat(
                                        sI?.generated_time,
                                        "dd mmm yyyy  HH:MM:ss TT",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%",
                                        border: "none",
                                        width: "20%",
                                      }}
                                    >
                                      {/* {formatToIndianRupees(
                                        sI?.service_amount || 0,
                                      )} */}
                                      {formatToIndianRupees(
                                        sI.total_amount || 0,
                                        settInvoice?.invoice_currency,
                                      )}
                                    </td>
                                  </tr>
                                  <hr></hr>
                                </>
                              );
                            },
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {settInvoice?.serviceInvoices?.map((invoice, index) => {
                  console.log("index:", index);
                  return (
                    <div
                      key={index}
                      style={{
                        width: "600px",
                        // marginTop: isDownload
                        //   ? index === 0
                        //     ? "200px"
                        //     : "81px"
                        //   : "40px",
                        marginTop: "20px",
                        border: "1px solid rgba(215, 218, 224, 0.4)",
                        borderRadius: "5px",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        color: "#3B3B3B",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div
                        key={index}
                        className={`reusable-table-containar scroll-container`}
                        style={{ marginBottom: "20px" }}
                      >
                        <div
                          style={{
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <table className={`reusable-table-view`}>
                            <thead style={{ width: "100%" }}>
                              <tr
                                className="reusable-table-view-header-row"
                                style={{
                                  height: isDownload ? "30px" : "45px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <th
                                  style={{
                                    textAlign: "center",
                                    width: "20%",
                                    display: "inline-block",
                                    fontSize: isDownload ? "11px" : "12px",
                                  }}
                                >
                                  Request No.
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    width: "20%",
                                    display: "inline-block",
                                    fontSize: isDownload ? "11px" : "12px",
                                  }}
                                >
                                  Acre
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    width: "40%",
                                    display: "inline-block",
                                    fontSize: isDownload ? "11px" : "12px",
                                  }}
                                >
                                  Date
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    width: "20%",
                                    display: "inline-block",
                                    fontSize: isDownload ? "11px" : "12px",
                                  }}
                                >
                                  Charges
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoice?.map((sI, index) => {
                                return (
                                  <>
                                    <tr
                                      key={index}
                                      className="reusable-table-view-data-row"
                                      style={{
                                        height: isDownload ? "30px" : "45px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                      align="center"
                                    >
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          height: "100%",
                                          border: "none",
                                          width: "20%",
                                        }}
                                      >
                                        {sI.req_number}
                                      </td>
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          height: "100%",
                                          border: "none",
                                          width: "20%",
                                        }}
                                      >
                                        {sI?.price_by == "acre"
                                          ? squareKilometersToAcres(
                                              sI.service_completed_area,
                                            )
                                          : Number(sI.service_completed_area)}
                                      </td>
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          height: "100%",
                                          border: "none",
                                          width: "40%",
                                        }}
                                      >
                                        {dateFormat(
                                          sI.payment_date,
                                          "dd mmm yyyy  HH:MM:ss TT",
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          height: "100%",
                                          border: "none",
                                          width: "20%",
                                        }}
                                      >
                                        {/* {settInvoice?.bhumeet_coupons_amount <=
                                        0
                                          ? formatToIndianRupees(
                                              sI.total_amount_without_bhumeet_coupon ||
                                                0,
                                            )
                                          : formatToIndianRupees(
                                              sI.total_amount || 0,
                                            )} */}

                                        {settInvoice?.bhumeet_coupons_amount <=
                                        0
                                          ? formatAmountWithSymbol(
                                              sI.total_amount_without_bhumeet_coupon ||
                                                0,
                                              user?.country_code,
                                              user?.dsp?.invoice_currency,
                                            )
                                          : formatAmountWithSymbol(
                                              sI.total_amount || 0,
                                              user?.country_code,
                                              user?.dsp?.invoice_currency,
                                            )}
                                      </td>
                                    </tr>
                                    <hr></hr>
                                  </>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>

          <div
            style={{
              width: "620px",
              border: "1px solid rgba(215, 218, 224, 0.4)",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              color: "#3B3B3B",
              backgroundColor: "#fff",
              margin: "15px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "20px",
                fontWeight: "bold",
                fontSize: "18px",
                alignItems: "center",
              }}
            >
              {/* <span>Total Service Charges</span> */}
              <span>Total amount to be paid</span>
              {settInvoice?.invoice_type ==
              DSP_INVOICES_TYPES.INCENTIVE_TO_DSP ? (
                <span>
                  {formatAmountWithSymbol(
                    getTotalServiceAmount() || 0,
                    user?.country_code,
                  )}
                </span>
              ) : (
                <span>
                  {/* {formatAmountWithSymbol(
                    settInvoice?.service_amount || 0,
                    user?.country_code,
                  )} */}
                  {/* {formatAmountWithSymbol(
                    Number(settInvoice?.service_amount) +
                      Number(settInvoice?.tax_amount || 0) || 0,
                    user?.country_code,
                    settInvoice?.invoice_currency,
                  )} */}
                  {formatAmountWithSymbol(
                    settInvoice?.total_amount || 0,
                    user?.country_code,
                    settInvoice?.invoice_currency,
                  )}
                </span>
              )}
            </div>
          </div>
        </div>
        <div
          id="debit-note-section"
          style={{
            border: isDownload ? "none" : "1px solid rgba(215, 218, 224, 0.4)",
            borderRadius: "5px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            color: "#3B3B3B",
            marginBottom: "10px",
            backgroundColor: "#fff",
            fontSize: isDownload ? "10px" : "inherit",
            lineHeight: isDownload ? "1.3" : "inherit",
          }}
        >
          {settInvoice?.debit_note && (isDebitNote || !settInvoice?.request_id) && (
            <div style={{ padding: "20px 30px" }}>
              <DebitNotesDetailsContainer DebitNote={settInvoice.debit_note} />
            </div>
          )}
          {settInvoice?.invoice_terms_and_conditions && (
            <div
              // style={{ padding: "20px 30px", fontSize: "12px", color: "black" }}
              style={{
                padding: isDownload ? "10px 20px" : "20px 30px",
                fontSize: "14px",
                color: "black",
              }}
            >
              {settInvoice?.invoice_terms_and_conditions ? (
                <>
                  <p>
                    BhuMeet terms and conditions apply. Refer to website for
                    more details.
                  </p>
                  <p style={{ padding: "10px 0px" }}>
                    <b>TERMS OF SERVICE</b>
                  </p>
                  <div style={{ lineHeight: "1.8" }}>
                    {/* {settInvoice?.invoice_terms_and_conditions
                      .split(/(?=\d+\.)/)
                      .filter((point) => point.trim())
                      .map((point, i) => (
                        <p key={i} style={{ margin: "4px 0" }}>
                          {point.trim()}
                        </p>
                      ))} */}

                    {settInvoice?.invoice_terms_and_conditions
                      .split(/\\n|\n/) // ← dono handle karo
                      .filter((point) => point.trim())
                      .map((point, i) => (
                        <p key={i} style={{ margin: "4px 0" }}>
                          {point.trim()}
                        </p>
                      ))}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DspInvoiceDetails;
